import { useLocation } from "react-router-dom";
import { useIsMobile } from "@/hooks";
import { LegalFooter } from "@/components/legal/LegalFooter";

const AUTH_SHELL_PATHS = new Set(["/login", "/register"]);

/**
 * Hides the global legal strip on auth split-layout routes where the footer adds noise.
 * On small screens, /weekly-planner already has a bottom nav — repeating the brand + legal
 * block below the plan added a large empty band; legal pages remain linkable from profile / landing.
 */
export function ConditionalLegalFooter() {
  const { pathname } = useLocation();
  const isMobile = useIsMobile();
  if (AUTH_SHELL_PATHS.has(pathname)) {
    return null;
  }
  if (isMobile && pathname === "/weekly-planner") {
    return null;
  }
  return <LegalFooter />;
}
